import NextImage from 'next/image';
import { useTranslation } from 'next-i18next';

import { INSTAGRAM_LINK, INSTAGRAM_NAME, PUBLIC_IMAGES } from '../../../../config';

import { Button } from '@/components/shared/Button';
import { Link } from '@/components/shared/Link';

export const PhoneFooter = () => {
  const { t } = useTranslation();

  return (
    <div
      className="relative m-auto flex h-[202px] w-full justify-center bg-green  md:h-[260px]"
      style={{
        background: 'linear-gradient(90deg, #C7DABB 0%, #55785A 100%)',
      }}
    >
      <div className="container relative !pb-0 !pl-0">
        <div
          className="absolute -bottom-16 h-80 w-44 bg-contain bg-bottom bg-no-repeat md:-bottom-36 md:h-[460px] md:w-80"
          style={{ backgroundImage: `url(${PUBLIC_IMAGES.FOOTER_BANNER})` }}
        />
        <div className="absolute bottom-0 right-[115px] z-20 h-[150px] w-[144px] md:right-[48%] lg:right-[55%]">
          <NextImage alt={'leaf'} height={300} width={300} src={PUBLIC_IMAGES.LEAF_LEFT} />
        </div>
        <div className="absolute -right-[40px] bottom-[31px] z-10 h-[96px] w-[120px] md:bottom-0 md:h-[215px] md:w-[204px]">
          <NextImage alt={'leaf'} height={300} width={300} src={PUBLIC_IMAGES.LEAF_RIGHT} />
        </div>
        <div className=" relative z-40 ml-auto max-w-[140px] text-right md:max-w-[370px]  lg:max-w-[480px]">
          <p className="font-bold text-white lg:text-xl">
            {t('content-page.banner.text')}
            <br />
            <span className="text-black">{INSTAGRAM_NAME}</span>
          </p>
          <Link href={INSTAGRAM_LINK} target="_blank">
            <Button className="mt-6">{t('buttons.follow')}</Button>
          </Link>
        </div>
      </div>
    </div>
  );
};
